module.exports = __webpack_public_path__ + "static/media/undraw_content.f657347b.svg";